import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { subscriptionPick } from '../../../../../actions/subscriptions';
import styles from './withRedirect.scss';

function withRedirect(WrappedComponent) {
  const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

  class WithRedirect extends Component {
    static displayName = `WithRedirect(${wrappedComponentName})`;

    static getDerivedStateFromProps({
      history,
      service,
      dispatchSubscriptionPick,
    }, { initialized }) {
      if (initialized || !service) {
        history.push('/subscriptions');
        return null;
      }

      dispatchSubscriptionPick(service);

      return {
        initialized: true,
      };
    }

    /* eslint-disable react/no-unused-state */
      state = {
        initialized: false,
      };

    handleDoneClick = () => {
      global.location.href = global.location.origin;
    };

    render() {
      return (
        <div className={styles.root}>
          <WrappedComponent
            {...this.props}
            title="Thank you for subscribing"
            confirmation
            onClick={this.handleDoneClick}
                 />
        </div>
      );
    }
  }

  return compose(
    withRouter,
    connect(
      state => ({ service: state.confirmation.service }),
      { dispatchSubscriptionPick: subscriptionPick },
    ),
    setPropTypes({
      dispatchSubscriptionPick: PropTypes.func.isRequired,
    }),
  )(WithRedirect);
}

export default withRedirect;
